/**
 * Safely detect language from URL path
 * Only matches exact language codes in the first path segment
 * Prevents false matches like /debt-freedom-calculator matching /de
 * 
 * @param {string} path - URL pathname
 * @returns {string} - Detected language code (en, es, fr, pt, de, it, nl) or 'en' as default
 */

// Supported language codes
export const supportedLanguages = ['en', 'de', 'es', 'fr', 'pt', 'it', 'nl'];

export function detectLanguage(path) {
  if (!path) return 'en';
  
  // Extract first segment after leading slash
  const firstSegment = path?.split('/')?.[1];
  
  // Only return language if first segment exactly matches a supported language
  if (supportedLanguages?.includes(firstSegment)) {
    return firstSegment;
  }
  
  // Default to English
  return 'en';
}
